// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "community-home .community-home-container{height:100%}community-home .com-home-map-container{height:95%}community-home .hide-column{display:none}.markercluster-map{height:90vh}.community-home-container{height:100%}.com-home-map-container{height:95%}.hide-column{display:none}\n", ""]);
// Exports
module.exports = exports;
